// TOP LEVEL IMPORTS
import React from 'react';
import styled from 'styled-components';
// ANTD
import Layout from 'antd/lib/layout';
import Menu from 'antd/lib/menu';
import Icon from 'antd/lib/icon';
import 'antd/lib/layout/style/css';
// LIB
import constants from 'lib/constants';
import AccountHelpers from 'lib/helpers/AccountHelpers/index';
import ApolloClient from '../../../ApolloClient/index';

// CONSTANTS & DESTRCUTURING
// ====================================

const {
  Header, Content, Footer, Sider,
} = Layout;

const SubMenu = Menu.SubMenu;

// STYLED COMPONENTS
// ====================================
const Logo = styled.img`
  height: 32px;
  background: rgba(255, 255, 255, 0.2);
  margin: 10px;
  margin-left: 25px;
`;

// EXPORTED COMPONENT
// ====================================
class AdminLayout extends React.Component {
  state = {
    collapsed: false,
  };

  onCollapse = collapsed => {
    console.log(collapsed);
    this.setState({ collapsed });
  };

  onMenuSelect = async ({ item, key, selectedKeys }) => {
    if (key === 'logout') {
      await AccountHelpers.handleLogout();
      await ApolloClient.resetStore();
      return this.props.history.push('login');
    }
    this.props.history.push(key);
  };

  render() {
    const { children, currentUser } = this.props;
    return (
      <Layout style={{ minHeight: '100vh' }}>
        <Sider collapsible theme="light" collapsed={this.state.collapsed} onCollapse={this.onCollapse}>
          <Logo src={constants.images.logoBlack} alt="cclariti" />
          <Menu onSelect={this.onMenuSelect} theme="light" defaultSelectedKeys={['1']} mode="inline">
            <Menu.Item key="/admin">
              <Icon type="home" />
              <span>Home</span>
            </Menu.Item>
            <Menu.Item key="/admin/users">
              <Icon type="user" />
              <span>Users</span>
            </Menu.Item>
            <Menu.Item key="/admin/organizations">
              <Icon type="team" />
              <span>Organizations</span>
            </Menu.Item>
            <Menu.Item key="/admin/dashboards">
              <Icon type="pie-chart" />
              <span>Dashboards</span>
            </Menu.Item>
            <Menu.Item key="/admin/logs">
              <Icon type="pie-chart" />
              <span>Activity Logs</span>
            </Menu.Item>
            <Menu.Item key="logout">
              <Icon type="minus-square" theme="outlined" />
              <span>Logout</span>
            </Menu.Item>
          </Menu>
        </Sider>
        <Layout>
          {/* <Header style={{ background: '#fff', padding: 0 }} /> */}
          <Content style={{ margin: '16px' }}>
            <div>{children}</div>
          </Content>
          <Footer style={{ textAlign: 'center' }}>CClariti ©2018</Footer>
        </Layout>
      </Layout>
    );
  }
}
// STYLE-COMPONENTS
// ===================================
const Container = styled.div`
  height: 100%;
  width: 100%;
  max-width: 100%;
  background-color: #fff;
`;

// EXPORT
// ===================================
// export default ({ children, currentUser }) => (
//   <Container>
//     <React.Fragment>
//       <div>{children}</div>
//     </React.Fragment>
//   </Container>
// );

export default AdminLayout;



// WEBPACK FOOTER //
// ./src/components/layout/AdminLayout/index.js